/* NORD PDP — opruimen van placeholders + vertrouwensbalk */
(function () {
  'use strict';

  function cleanPlaceholders() {
    /* 1. Verberg alle losse 'Mijn winkel' vendor-teksten */
    document.querySelectorAll('#MainContent p, #MainContent span, #MainContent div, #MainContent a').forEach(function (el) {
      if (el.children.length === 0 && el.textContent.trim() === 'Mijn winkel') {
        var parent = el.closest('.product__text') || el;
        parent.style.display = 'none';
      }
    });

    /* 2. Dubbele titel: verberg de tweede identieke kop */
    var seen = {};
    document.querySelectorAll('#MainContent h1, #MainContent h2').forEach(function (h) {
      var t = h.textContent.trim();
      if (!t) return;
      if (seen[t]) { h.style.display = 'none'; } else { seen[t] = true; }
    });
  }

  /* 3. Verwijder de dubbele USP-grid uit main-product.liquid.
     Die herhaalt de vertrouwensbalk hieronder en bevat een
     onjuiste retour-claim.

     LET OP — in sections/main-product.liquid mist bij het eerste
     .ns-trust-item de afsluitende </div>. De browser hangt daardoor
     alles wat erna komt (de PRODUCTBESCHRIJVING, app-blokken, de
     'alle details'-link) IN dit raster. Het raster zomaar weghalen
     gooide die inhoud dus mee weg: de beschrijving verdween van elke
     productpagina. Daarom halen we eerst alles wat geen trust-item is
     naar buiten en pas daarna het raster zelf weg. Wordt de ontbrekende
     </div> ooit in de liquid hersteld, dan blijft dit gewoon werken:
     er valt dan simpelweg niets te verplaatsen. */
  function removeLegacyTrustGrid() {
    document.querySelectorAll('.ns-trust-grid').forEach(function (grid) {
      var parent = grid.parentNode;
      if (parent) {
        Array.prototype.slice.call(grid.children).forEach(function (child) {
          if (!child.classList || !child.classList.contains('ns-trust-item')) {
            parent.insertBefore(child, grid);
          }
        });
      }
      grid.remove();
    });
  }

  function injectTrust() {
    var form = document.querySelector('.product-form');
    if (!form || document.querySelector('.nord-pdp-trust')) return;
    var check = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
    var truck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="7" width="13" height="10" rx="1"/><path d="M14 10h4l3 3v4h-7"/><circle cx="6.5" cy="18.5" r="1.8"/><circle cx="17" cy="18.5" r="1.8"/></svg>';
    var html = '<div class="nord-pdp-trust">'
      + '<div class="nord-pdp-trust__row">' + check + '120 nachten proefslapen</div>'
      + '<div class="nord-pdp-trust__row">' + check + 'Altijd gratis verzending</div>'
      + '<div class="nord-pdp-trust__row">' + check + '10 jaar garantie op alle matrassen</div>'
      + '<div class="nord-pdp-trust__delivery">' + truck + 'Bezorgd in 2–5 werkdagen in Nederland &amp; België</div>'
      + '</div>';
    form.insertAdjacentHTML('afterend', html);
  }

  function init() {
    cleanPlaceholders();
    removeLegacyTrustGrid();
    injectTrust();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Shopify section reloads (theme editor / variant wissel) */
  document.addEventListener('shopify:section:load', init);
})();
